module.exports = __webpack_public_path__ + "public/img/menyusun strategi untuk spesialis pemasaran digital-2.15f72287.png";